import * as React from 'react';
import { cn } from '@/lib/utils';

interface TooltipProps {
  children: React.ReactNode;
  content: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, content, side = 'bottom', className }, ref) => {
    const [show, setShow] = React.useState(false);

    return (
      <div
        ref={ref}
        className={cn('relative inline-flex', className)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
        {show && (
          <div
            role="tooltip"
            className={cn(
              'absolute z-[100] whitespace-nowrap rounded-md bg-foreground px-2.5 py-1.5 text-xs font-medium text-background shadow-lg',
              'animate-in fade-in-0 zoom-in-95 duration-150',
              side === 'right' && 'left-full top-1/2 ml-2 -translate-y-1/2',
              side === 'left' && 'right-full top-1/2 mr-2 -translate-y-1/2',
              side === 'top' && 'bottom-full left-1/2 mb-2 -translate-x-1/2',
              side === 'bottom' && 'top-full left-1/2 mt-2 -translate-x-1/2'
            )}
          >
            {content}
          </div>
        )}
      </div>
    );
  }
);

Tooltip.displayName = 'Tooltip';

